// Maps the current route to a help "page key". The Help sheet then reads
// help.<pageKey>.title / help.<pageKey>.body from i18n, so the copy is
// translatable and works offline (no network, no AI).
const ROUTE_KEYS = [
  { prefix: '/dashboard', key: 'dashboard' },
  { prefix: '/workout', key: 'workout' },
  { prefix: '/diet', key: 'diet' },
  { prefix: '/supplements', key: 'supplements' },
  { prefix: '/social', key: 'social' },
  { prefix: '/measurements', key: 'measurements' },
  { prefix: '/accessibility', key: 'accessibility' },
  { prefix: '/my-coach', key: 'myCoach' },
  { prefix: '/exercises', key: 'exercises' },
];

export function pageKeyForPath(pathname) {
  // Match on whole segments only: '/workouts-archive' must NOT match '/workout'.
  const match = ROUTE_KEYS.find(
    ({ prefix }) => pathname === prefix || pathname.startsWith(prefix + '/')
  );
  return match ? match.key : 'default';
}

// Page keys that have authored help content.
export const HELP_PAGE_KEYS = ROUTE_KEYS.map((r) => r.key).concat('default');
